import { render } from "./QandaQuestionList.vue?vue&type=template&id=7aabdd0c&scoped=true&ts=true"
import script from "./QandaQuestionList.vue?vue&type=script&lang=ts"
export * from "./QandaQuestionList.vue?vue&type=script&lang=ts"

import "./QandaQuestionList.vue?vue&type=style&index=0&id=7aabdd0c&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aabdd0c"]])

export default __exports__